import { Box, styled } from '@mui/material'

export const DeviceLoadingStateContainer = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})
